import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UlItem } from '@com-delta-idp/mnx-ui-kit';
import { AddSqaContent } from './modals/add-sqa.interface';

@Component({
  selector: 'idp-add-sqa',
  templateUrl: './add-sqa.component.html',
  styleUrls: ['./add-sqa.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddSqaComponent implements OnInit, OnDestroy {
  addSqaForm!: UntypedFormGroup;
  answerOneFocused: boolean;
  answerTwoFocused: boolean;

  @Input() content: AddSqaContent | null;
  @Input() machCore = false;

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() formSubmitEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() inputChange: EventEmitter<UlItem> = new EventEmitter<UlItem>();
  @Output() resetForm: EventEmitter<void> = new EventEmitter<void>();
  @Output() triggerClose = new EventEmitter();

  ngOnInit(): void {
    this.addSqaForm = this.content.formGroup;
  }

  questionOneFormControl(): UntypedFormControl {
    return this.addSqaForm?.get('questionOne') as UntypedFormControl;
  }

  answerOneFormControl(): UntypedFormControl {
    return this.addSqaForm?.get('answerOne') as UntypedFormControl;
  }

  questionTwoFormControl(): UntypedFormControl {
    return this.addSqaForm?.get('questionTwo') as UntypedFormControl;
  }

  answerTwoFormControl(): UntypedFormControl {
    return this.addSqaForm?.get('answerTwo') as UntypedFormControl;
  }

  get showErrorMessageSqaQuestionOne(): boolean {
    const control = this.questionOneFormControl();
    return (
      control.invalid && this.content.formAttributes.questionOneControlTouched
    );
  }

  get showErrorMessageSqaQuestionTwo(): boolean {
    const control = this.questionTwoFormControl();
    return (
      control.invalid && this.content.formAttributes.questionTwoControlTouched
    );
  }

  get showErrorMessageSqaAnswerOne(): boolean {
    const control = this.answerOneFormControl();
    return (
      control.invalid && this.content.formAttributes.answerOneControlTouched
    );
  }

  get showErrorMessageSqaAnswerTwo(): boolean {
    const control = this.answerTwoFormControl();
    return (
      control.invalid && this.content.formAttributes.answerTwoControlTouched
    );
  }

  onFocusFirstInvalidField(): void {
    this.focusInvalidField.emit();
  }

  onChange(): void {
    this.inputChange.emit();
  }

  onChangeDropdown(event: UlItem): void {
    this.inputChange.emit(event);
  }

  onSubmit(): void {
    this.formSubmitEvent.emit();
  }

  onClosePop(): void {
    this.closeOverlayMessage.emit(false);
  }

  onFocussedOut(fieldName: string): void {
    this.fieldFocusOut.emit(fieldName);
  }

  onFocusedAnswerOne() {
    this.answerOneFocused = true;
  }

  onFocusedAnswerTwo() {
    this.answerTwoFocused = true;
  }

  onFocussedOutAnswerOne() {
    this.answerOneFocused = false;
  }

  onFocussedOutAnswerTwo() {
    this.answerTwoFocused = false;
  }

  ngOnDestroy() {
    this.resetForm.emit();
  }
}
